import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  contentItem: {
    alignItems: "center",
    justifyContent: "space-evenly",
    width: "100%",
    minHeight: 90,
    borderRadius: 8,
    padding: 10,
    flexDirection: "row",
    marginBottom: 10,
    marginTop: 10,
    flexWrap: "wrap",
    shadowColor: "#000",
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 4,
  },

  btnVenderDisabled: {
    backgroundColor: "#FFF",
    borderColor: "#FFF",
    borderWidth: 0.5,
    borderRadius: 4,
  },

  btnVenderTxtDisabled: {
    color: "#FFFFFF",
  },

  txtEmitirCerti: {
    marginBottom: 20,
    textAlign: "center",
    fontSize: 18,
    backgroundColor: "#077A97",
    color: "#FFF",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 4,
  },

  certificateHeaders: {
    textAlign: "center",
    textTransform: "uppercase",
    fontSize: 14,
    color: "#077A97",
  },

  columnContainer: {
    maxWidth: 120,
    minWidth: 120,
    flexDirection: "column",
    alignItems: "center",
  },

  ativoImgRowContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },

  textsItem: {
    marginLeft: 20,
  },

  infoPrice: {
    flexDirection: "row",
    justifyContent: "flex-start",
  },

  titleCoin: {
    fontSize: 12,
    fontWeight: "bold",
    marginTop: 5,
  },

  dadosAtivo: {
    flexWrap: "wrap",
    fontSize: 14,
    textAlign: "center",
  },

  img: {
    width: 24,
    height: 24,
    borderRadius: 12,
    overflow: "hidden",
  },

  nomeAtivoContainer: {
    marginLeft: 12,
  },

  contentPurchase: {
    paddingHorizontal: 25,
    marginTop: 10,
  },

  titlePurchase: {
    textAlign: "center",
    marginBottom: 20,
  },

  contentPurchaseAmount: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: 10,
  },

  contentOrders: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  orderPurchases: {
    fontSize: 12,
  },

  orderPurchasesBold: {
    fontSize: 12,
    fontWeight: "bold",
  },

  orderSale: {
    fontSize: 12,
  },

  orderSaleBold: {
    fontSize: 12,
    fontWeight: "bold",
  },

  contentDescriptionOrders: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 5,
  },

  textDescriptionsOrders: {
    fontSize: 12,
  },

  contentPurchaseOrSale: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  amountPurchase: {
    fontSize: 12,
  },

  pricePurchase: {
    fontSize: 12,
    color: "green",
  },

  amountSale: {
    fontSize: 12,
  },

  priceSale: {
    fontSize: 12,
    color: "#B90000",
  },

  btnComprar: {
    minWidth: 120,
    height: 34,
    paddingHorizontal: 6,
    paddingVertical: 4,
    borderRadius: 4,
    borderColor: "#077A97",
    borderWidth: 0.5,
    backgroundColor: "#077A97",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    marginRight: 10,
  },

  btnVender: {
    minWidth: 120,
    height: 34,
    paddingHorizontal: 6,
    paddingVertical: 4,
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: "#077A97",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    marginRight: 10,
  },

  btnComprarText: {
    color: "#fff",
  },

  btnVenderText: {
    color: "#077A97",
  },

  btnEmitirCertificado: {
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 200,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 0.5,
    borderRadius: 4,
    borderColor: "#ffffff",
    marginVertical: 12,
    alignSelf: "center",
    backgroundColor: "#0A9396",
    color: "#ffffff",
  },

  numberInput: {
    flex: 1,
    backgroundColor: "#f1f1f1",
    borderWidth: 1,
    borderColor: "#ccc",
  },

  modalOverlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },

  modalContainer: {
    width: "30%",
    backgroundColor: "#fff",
    borderRadius: 16,
    paddingVertical: 24,
    paddingHorizontal: 20,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 10,
  },

  observationText: {
    marginTop: 16,
    fontSize: 14,
    color: "#555",
    textAlign: "justify",
    lineHeight: 20,
  },

  closeIconContainer: {
    alignSelf: "flex-end",
    position: "absolute",
    top: 16,
    right: 16,
    padding: 8,
    zIndex: 10,
  },

  actionButton: {
    marginTop: 24,
    backgroundColor: "#077A97",
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 12,
    alignSelf: "stretch", // garante largura total
    alignItems: "center", // centraliza o texto
  },

  actionButtonText: {
    color: "#FFF",
    fontSize: 16,
    fontWeight: "600",
    textAlign: "center",
  },

  modalCenteredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },

  modalTitle: {
    fontSize: 18,
    fontWeight: "700",
    color: "#222",
    marginBottom: 16,
    textAlign: "center",
  },

  modalView: {
    width: "40%",
    marginTop: 40,
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 6,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 5,
  },

  balanceInfo: {
    width: "100%",
    marginTop: 20,
    marginBottom: 12,
    paddingHorizontal: 8,
  },

  balanceLabel: {
    fontSize: 15,
    fontWeight: "500",
    color: "#555",
    marginBottom: 6,
    textAlign: "left",
  },

  balanceValue: {
    fontSize: 18,
    fontWeight: "700",
    color: "#077A97",
    textAlign: "left",
  },
});

export default styles;
